import { render, staticRenderFns } from "./ChatbotInvitationRegister.vue?vue&type=template&id=635bf14c&"
import script from "./ChatbotInvitationRegister.vue?vue&type=script&lang=js&"
export * from "./ChatbotInvitationRegister.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports